<template>
  <span>
    <AccountLink v-bind:account="account" />: {{balance | round | delim}}
    ({{limit | round | delim}} / {{limit_peer | round | delim}})
  </span>
</template>

<script>
import AccountLink from './AccountLink.vue'

export default {
  name: 'TrustLineSummary',

  components : {AccountLink},

  props : {
    trust_line : Object
  },

  computed : {
    account : function(){
      return this.trust_line["account"];
    },

    balance : function(){
      return this.trust_line["balance"];
    },

    limit : function(){
      return this.trust_line["limit"];
    },

    limit_peer : function(){
      return this.trust_line["limit_peer"];
    }
  }
}
</script>
